import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { UserService } from '../../../user/user.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { InspectionService } from '../../../inspection/inspection.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-admin-assignment',
  templateUrl: './admin-assignment.component.html',
  styleUrls: ['./admin-assignment.component.scss'],
})
export class AdminAssignmentInspectionComponent implements OnInit {
  constructor(
    public userService: UserService,
    private fb: FormBuilder,
    public inspectionService: InspectionService,
    private toastr: ToastrService,
  ) {}

  assignmentForm!: FormGroup;
  inspectionId;
  assignees = [];
  selectedAdmin;
  @ViewChild('modalRef', { static: false }) modalRef!: ModalDirective;
  @Output() onClose = new EventEmitter<boolean>();
  @Output() onConfirm = new EventEmitter<any>();

  async ngOnInit() {
    this.assignmentForm = this.fb.group({
      assignee: [null],
    });

    this.assignees = await this.userService.assignees();

    if (this.assignees.length > 0) {
      const currentUser = await this.userService.profile();
      const currentUserIndex = this.assignees.findIndex(a => a.id === currentUser.id);
      let signedInUser = null;
      if (currentUserIndex !== -1) {
        signedInUser = this.assignees.splice(currentUserIndex, 1)[0];
      }
      this.assignees = this.assignees.sort((a, b) => a.name.localeCompare(b.name));
      this.assignees = signedInUser ? [signedInUser, ...this.assignees] : [...this.assignees];
    }
  }

  openModal(inspection): void {
    this.selectedAdmin = inspection.assignee;
    this.inspectionId = inspection.id;
    if (inspection.assignee) {
      this.assignmentForm.get('assignee').setValue({
        id: inspection.assignee.id,
        name: inspection.assignee.name,
      });
    } else {
      this.assignmentForm.get('assignee').setValue(null);
    }

    this.modalRef.show();
  }

  closeModal(): void {
    this.modalRef.hide();
    this.onClose.emit(false);
  }

  async confirmModal(): Promise<void> {
    if (this.selectedAdmin !== this.assignmentForm.get('assignee').value) {
      this.inspectionId = this.inspectionId;
      let assigneeId = null;
      if (this.assignmentForm.get('assignee').value) {
        assigneeId = this.assignmentForm.get('assignee').value.id;
      }
      await this.inspectionService.setAssignment(this.inspectionId, assigneeId);
      this.toastr.success('Inspection updated successfully!');
      this.onConfirm.emit({ admin: this.selectedAdmin, inspectionId: this.inspectionId });
    }
    this.modalRef.hide();
  }

  async onAssigneeSelect(admin: any) {
    this.selectedAdmin = admin;
    this.selectAssignee(admin);
  }

  async selectAssignee(data) {
    if (data) {
      this.assignmentForm.get('assignee').setValue({
        id: data.id,
        name: data.name,
      });
    } else {
      this.assignmentForm.get('assignee').setValue(null);
    }
  }

  clearAssignee() {
    this.assignmentForm.get('assignee').setValue(null);
  }
  getInitials(name: string): string {
    const words = name.trim().split(/\s+/);
    return words.length >= 2 ? words[0][0] + words[1][0] : words[0][0];
  }
}
